import Vue from 'vue'
import axios from 'axios'
import store from '@/store/index'
import { jumpHome } from '@/assets/js/utils/utils'

/**
 * axios实例
 * @param  {string} baseURL 接口域名对应配置的key
 * @param  {boolean} compatible 是否兼容前期非统一接口,直接抛出数据，不做统一处理
 * @return {object} axios实例
 */
export function axiosInstance (baseURL, compatible = false) {
  const instance = axios.create({ withCredentials: true })

  instance.interceptors.request.use(
    function (config) {
      config.baseURL = Vue.prototype.$APP_CONFIG[baseURL]

      const userInfo = store.state.user.userInfo
      if (userInfo?.accessToken) {
        config.headers.accessToken = userInfo.accessToken
      }

      return config
    },
    function (error) {
      return Promise.reject(error)
    },
  )

  if (compatible) {
    instance.interceptors.response.use(
      function (response) {
        return response.data
      },
      function (error) {
        return Promise.reject(error)
      },
    )
  } else {
    instance.interceptors.response.use(
      function (response) {
        if (response.status === 200) {
          const { pageInfo, responseEntity, serverResult, msg, code } = response.data
          const msgText = serverResult?.resultMsg || msg
          const codeText = serverResult?.resultCode || `${code}`
          if (codeText === '200' || codeText === '10015') {
            // 返回数据
            return pageInfo ?? responseEntity ?? true
          } else if (codeText === '401'||codeText === '500') {//返回登录页
            // 提示登录异常
            // if (msgText) {
            //   Message.error(msgText)
            // }
            // store.dispatch('user/clearUserInfo') // 清除原有用户信息和状态
            // store.commit('user/setNeedLogin', false)
            window.location.href = jumpHome()
          } else if (codeText === '403') {
            // 提示权限异常
            if (msgText) {
              Message.error(msgText)
            }
            // setTimeout(() => {
            //   window.location.href = jumpHome()
            // }, 1000)
          } else {
            if (codeText !== '10019') { // 用户未登录不提示
              // 提示错误信息
              // if (msgText) {
              //   Message.error(msgText)
              // }
            }
            // 抛出异常
            return Promise.reject(msgText)
          }
        } else {
          // Message.error('请求出错，请稍后重试')
          return Promise.reject(response.statusText)
        }
      },
      function (error) {
        // Message.error('请求出错，请稍后重试')
        return Promise.reject(error)
      },
    )
  }

  return instance
}
